import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(name, email, password);
      nav("/");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="mx-auto flex min-h-[80vh] max-w-md flex-col justify-center px-5 py-16">
      <h1 className="font-display text-3xl font-900 tracking-tighter text-white">Create account</h1>
      <p className="mt-2 text-zinc-500">Join the collectors at LaMotta.</p>
      <form onSubmit={submit} className="mt-8 space-y-4">
        <div>
          <label className="overline text-zinc-500">Name</label>
          <input data-testid="register-name" required value={name} onChange={(e) => setName(e.target.value)}
            className="mt-2 w-full rounded-xl border border-white/10 bg-card px-4 py-3 text-white outline-none transition-colors focus:border-primary" />
        </div>
        <div>
          <label className="overline text-zinc-500">Email</label>
          <input data-testid="register-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            className="mt-2 w-full rounded-xl border border-white/10 bg-card px-4 py-3 text-white outline-none transition-colors focus:border-primary" />
        </div>
        <div>
          <label className="overline text-zinc-500">Password</label>
          <input data-testid="register-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
            className="mt-2 w-full rounded-xl border border-white/10 bg-card px-4 py-3 text-white outline-none transition-colors focus:border-primary" />
        </div>
        {error && <p data-testid="register-error" className="text-sm text-red-400">{error}</p>}
        <button type="submit" disabled={loading} data-testid="register-submit"
          className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-primary px-7 py-3.5 font-medium text-white transition-transform hover:-translate-y-1 disabled:opacity-60">
          {loading ? <Loader2 className="animate-spin" size={18} /> : "Create account"}
        </button>
      </form>
      <p className="mt-6 text-center text-sm text-zinc-500">
        Have an account? <Link to="/login" data-testid="go-login" className="text-secondary hover:underline">Sign in</Link>
      </p>
    </div>
  );
}
